/**
 * TaskQueue - Gerencia uma fila de funções onde a função atual em progresso
 * executará automaticamente a próxima função na fila.
 *
 * Isso previne race conditions quando múltiplas operações assíncronas
 * (como substituição de tracks) são chamadas simultaneamente.
 */
export class TaskQueue {
  constructor() {
    this._queue = []
    this._currentTask = null
    this._onTaskComplete = this._onTaskComplete.bind(this)
  }

  /**
   * Adiciona uma nova função à fila. Será executada imediatamente
   * se nenhuma outra função estiver na fila.
   *
   * @param {Function} taskFunction - Função a ser enfileirada (recebe callback onFinish)
   */
  enqueue(taskFunction) {
    this._queue.push(taskFunction)
    this._executeNext()
  }

  /**
   * Se nenhuma tarefa está em execução, invoca a primeira tarefa da fila
   */
  _executeNext() {
    if (this._currentTask) {
      console.warn('[TaskQueue] Tarefa enfileirada enquanto outra está em progresso')
      return
    }

    this._currentTask = this._queue.shift() || null

    if (this._currentTask) {
      console.debug('[TaskQueue] Executando tarefa')

      try {
        this._currentTask(this._onTaskComplete)
      } catch (error) {
        console.error(`[TaskQueue] Falha na execução da tarefa: ${error}`)
        this._onTaskComplete()
      }
    }
  }

  /**
   * Prepara para invocar a próxima função na fila
   */
  _onTaskComplete() {
    this._currentTask = null
    console.debug('[TaskQueue] Tarefa concluída')
    this._executeNext()
  }
}

/**
 * Cria uma nova instância de TaskQueue
 */
export function createTaskQueue() {
  return new TaskQueue()
}

